import { isNil } from 'lodash';

export const formatPortfolioDescription = (isInternalProject: boolean, description?: string | null) =>
    isInternalProject && !isNil(description) ? `"${description}"` : description;
